import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    partType: "Consumable",
    filterPart: "",
}

const partsSlice = createSlice({
    name: 'partsSlice',
    initialState,
    reducers: {
        setPartType(state, action) {            
            state.partType = action.payload;            
        },
        setFilterPart(state, action) {
            state.filterPart = action.payload;
        }
    }
});

export const { setPartType, setFilterPart } = partsSlice.actions;
export default partsSlice.reducer;